/* cosmic-atc-overlay.js — injects hover ATC button on collection product cards */
(function () {
  'use strict';

  function initOverlays() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.cs-atc-overlay')) return;

      var variantId = card.getAttribute('data-product-id') ||
                      card.querySelector('[data-product-id]')?.getAttribute('data-product-id');

      var overlay = document.createElement('div');
      overlay.className = 'cs-atc-overlay';
      overlay.innerHTML = `
        <button class="cs-atc-btn" data-variant="${variantId}">Add to Cart</button>
        <button class="cs-wish-btn" aria-label="Add to wishlist">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M12 21C12 21 3 13.5 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 5.5-9 13-9 13z"/>
          </svg>
        </button>
      `;

      /* ATC button */
      overlay.querySelector('.cs-atc-btn').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = this;
        var vid = btn.getAttribute('data-variant');
        if (!vid) return;

        btn.textContent = 'Adding…';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          /* Refresh Horizon's cart bubble count */
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'View product';
          btn.disabled = false;
        });
      });

      var mediaWrap = card.querySelector('.product-card__link');
      if (mediaWrap) mediaWrap.style.position = 'relative';

      var imgWrap = card.querySelector('.media, [class*="media"]');
      if (imgWrap) {
        imgWrap.style.position = 'relative';
        imgWrap.appendChild(overlay);
      }
    });
  }

  /* Run on load and after infinite scroll / filter updates */
  document.addEventListener('DOMContentLoaded', initOverlays);
  document.addEventListener('shopify:section:load', initOverlays);

  /* Re-run when Horizon's results list updates (filter/sort) */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) initOverlays();
    });
  });
  var grid = document.querySelector('.product-grid-container');
  if (grid) observer.observe(grid, { childList: true, subtree: true });

})();

/* Inject WhatsApp help box into filter sidebar */
(function () {
  function addWaBox() {
    var sidebar = document.querySelector('.facets--vertical');
    if (!sidebar || sidebar.querySelector('.cs-filter-wa-box')) return;
    var box = document.createElement('div');
    box.className = 'cs-filter-wa-box';
    box.innerHTML = `
      <p>💬 Not sure which?</p>
      <span>Tell us the occasion and our team will help you choose.</span>
      <a href="https://wa.me/919344458130" target="_blank" rel="noopener">Ask on WhatsApp →</a>
    `;
    sidebar.appendChild(box);
  }
  document.addEventListener('DOMContentLoaded', addWaBox);
})();

/* Savings pill — inject inline with price */
(function () {
  function injectSavingsPill() {
    document.querySelectorAll('product-price').forEach(function (el) {
      if (el.querySelector('.cs-savings-pill')) return;
      var priceContainer = el.querySelector('[ref="priceContainer"]');
      if (!priceContainer) return;

      var salePrice = el.closest('[data-product-id]');
      if (!salePrice) return;

      var sale = priceContainer.querySelector('.price-item__group.price');
      var compare = priceContainer.querySelector('.compare-at-price');
      if (!sale || !compare) return;

      var saleText = Array.from(sale.childNodes)
  .filter(function(n){ return n.nodeType === 3; })
  .map(function(n){ return n.textContent; })
  .join('');
var compareText = Array.from(compare.childNodes)
  .filter(function(n){ return n.nodeType === 3; })
  .map(function(n){ return n.textContent; })
  .join('');
var saleAmt = parseFloat(saleText.replace(/[^0-9.]/g, '').replace(/^\./, ''));
var compareAmt = parseFloat(compareText.replace(/[^0-9.]/g, '').replace(/^\./, ''));
      if (isNaN(saleAmt) || isNaN(compareAmt) || compareAmt <= saleAmt) return;

      var savings = Math.round(compareAmt - saleAmt);
      var pill = document.createElement('span');
      pill.className = 'cs-savings-pill';
      pill.textContent = 'Save ₹' + savings.toLocaleString('en-IN');
      priceContainer.appendChild(pill);

    });
  }

  document.addEventListener('DOMContentLoaded', injectSavingsPill);
})();